import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MenuMobileService {
  _hiddenMobileMenu = new BehaviorSubject(false);
  constructor() { }

  get hiddenMobileMenu() {
    return this._hiddenMobileMenu.asObservable();
  }

  nextHiddenMobileMenu(hidden: boolean) {
    this._hiddenMobileMenu.next(hidden);
  }
}
